import { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

// Главная (category/grid) - 4 маленьких квадратика
export function CategoryIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M5.1 8.6H6.5C7.9 8.6 8.6 7.9 8.6 6.5V5.1C8.6 3.7 7.9 3 6.5 3H5.1C3.7 3 3 3.7 3 5.1V6.5C3 7.9 3.7 8.6 5.1 8.6Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4999 8.6H14.8999C16.2999 8.6 16.9999 7.9 16.9999 6.5V5.1C16.9999 3.7 16.2999 3 14.8999 3H13.4999C12.0999 3 11.3999 3.7 11.3999 5.1V6.5C11.3999 7.9 12.0999 8.6 13.4999 8.6Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4999 17.0004H14.8999C16.2999 17.0004 16.9999 16.3004 16.9999 14.9004V13.5004C16.9999 12.1004 16.2999 11.4004 14.8999 11.4004H13.4999C12.0999 11.4004 11.3999 12.1004 11.3999 13.5004V14.9004C11.3999 16.3004 12.0999 17.0004 13.4999 17.0004Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1 17.0004H6.5C7.9 17.0004 8.6 16.3004 8.6 14.9004V13.5004C8.6 12.1004 7.9 11.4004 6.5 11.4004H5.1C3.7 11.4004 3 12.1004 3 13.5004V14.9004C3 16.3004 3.7 17.0004 5.1 17.0004Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Чат с ИИ Ментором
export function ChatIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.95 14.949C12.8107 17.0885 9.64288 17.5508 7.05051 16.3519C6.66781 16.1978 6.35406 16.0733 6.05578 16.0733C5.22495 16.0782 4.19082 16.8838 3.65336 16.347C3.11589 15.8094 3.92209 14.7745 3.92209 13.9386C3.92209 13.6403 3.8025 13.3322 3.64843 12.9487C2.44898 10.3568 2.91188 7.1879 5.05119 5.04905C7.78214 2.3171 12.2191 2.3171 14.95 5.04835C17.6859 7.78453 17.681 12.2177 14.95 14.949Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7575 10.2895H12.7638"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.95134 10.2895H9.95764"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.14519 10.2895H7.15149"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Анализ рынка - круговая диаграмма
export function GraphIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M14.0963 10.0005C15.7815 10.0005 16.4815 9.35231 15.8593 7.22639C15.438 5.79398 14.2065 4.5625 12.7741 4.1412C10.6481 3.51898 10 4.21898 10 5.90416V7.77083C10 9.35231 10.6481 10.0005 11.9444 10.0005H14.0963Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1852 11.751C14.5824 14.7519 11.7046 16.9297 8.43145 16.3982C5.97496 16.0028 3.99811 14.026 3.59626 11.5695C3.07126 8.3093 5.23608 5.43152 8.22404 4.82227"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Персона (user-square)
export function UserSquareIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M13.9798 16.2356C13.4094 16.4041 12.7353 16.4819 11.9446 16.4819H8.05569C7.26495 16.4819 6.59088 16.4041 6.02051 16.2356C6.1631 14.5504 7.89366 13.2217 10.0001 13.2217C12.1066 13.2217 13.8372 14.5504 13.9798 16.2356Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9445 3.51855H8.05559C4.81485 3.51855 3.51855 4.81485 3.51855 8.05559V11.9445C3.51855 14.3945 4.25744 15.7361 6.02041 16.2352C6.163 14.55 7.89355 13.2213 10 13.2213C12.1065 13.2213 13.8371 14.55 13.9797 16.2352C15.7426 15.7361 16.4815 14.3945 16.4815 11.9445V8.05559C16.4815 4.81485 15.1852 3.51855 11.9445 3.51855ZM10 11.4065C8.7167 11.4065 7.67966 10.363 7.67966 9.07968C7.67966 7.79634 8.7167 6.7593 10 6.7593C11.2834 6.7593 12.3204 7.79634 12.3204 9.07968C12.3204 10.363 11.2834 11.4065 10 11.4065Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3204 9.07917C12.3204 10.3625 11.2834 11.406 10.0001 11.406C8.71673 11.406 7.67969 10.3625 7.67969 9.07917C7.67969 7.79584 8.71673 6.75879 10.0001 6.75879C11.2834 6.75879 12.3204 7.79584 12.3204 9.07917Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Исследования - лупа с сердечком
export function SearchFavoriteIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15.8334 9.67596C15.8334 13.0787 13.0787 15.8334 9.67596 15.8334C6.27318 15.8334 3.51855 13.0787 3.51855 9.67596C3.51855 6.27318 6.27318 3.51855 9.67596 3.51855"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4814 16.4818L15.1851 15.1855"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6205 6.19516C11.3936 5.4822 11.6471 4.5485 12.3989 4.30868C12.7943 4.17905 13.2927 4.46578 13.5714 4.84819C13.8306 4.45282 14.3779 4.15916 14.7668 4.28231C15.5187 4.52212 15.7427 5.4822 15.5158 6.19516C15.1593 7.32942 13.9149 7.91923 13.5714 7.91923C13.2214 7.91923 11.9899 7.34238 11.6205 6.19516Z"
        fill="#2197F1"
      />
    </svg>
  );
}

// Позиционирование - пьедестал со звездой
export function RankingIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.8417 11.2959H4.81485C4.10189 11.2959 3.51855 11.8792 3.51855 12.5922V16.4811H7.8417V11.2959Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8618 8.7041H9.13126C8.41829 8.7041 7.83496 9.28743 7.83496 10.0004V16.4819H12.1581V10.0004C12.1581 9.28743 11.5813 8.7041 10.8618 8.7041Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1851 13.2412H12.1582V16.482H16.4814V14.5375C16.4814 13.8245 15.898 13.2412 15.1851 13.2412Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3372 3.56437L10.6807 4.25141C10.7261 4.34863 10.8492 4.43937 10.9529 4.45233L11.5751 4.55604C11.9705 4.62085 12.0677 4.91251 11.7826 5.19121L11.2964 5.67732C11.2122 5.76158 11.1668 5.91714 11.1927 6.02733L11.3289 6.62363C11.439 7.09678 11.1863 7.27826 10.7714 7.03197L10.1881 6.68845C10.0844 6.62363 9.90941 6.62363 9.8057 6.68845L9.22237 7.03197C8.80756 7.27826 8.55478 7.09678 8.66496 6.62363L8.80108 6.02733C8.827 5.91714 8.78163 5.7551 8.69737 5.67732L8.21774 5.1977C7.93256 4.91251 8.0233 4.62732 8.42515 4.5625L9.04737 4.45882C9.15107 4.43937 9.27422 4.34864 9.31959 4.25789L9.66311 3.57084C9.85107 3.19491 10.1492 3.19493 10.3372 3.56437Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// План запуска MVP (task-square)
export function TaskSquareIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.2588 7.81543H13.934"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.06543 7.81567L6.59045 8.3407L8.16553 6.76562"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2588 12.7168H13.934"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.06543 12.7161L6.59045 13.2411L8.16553 11.666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.89974 16.9997H12.0999C15.6001 16.9997 17.0002 15.5996 17.0002 12.0994V7.89925C17.0002 4.39909 15.6001 2.99902 12.0999 2.99902H7.89974C4.39958 2.99902 2.99951 4.39909 2.99951 7.89925V12.0994C2.99951 15.5996 4.39958 16.9997 7.89974 16.9997Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Справочная (book)
export function BookIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.9999 13.3171V4.8682C16.9999 4.0282 16.3139 3.4052 15.4809 3.4752H15.4389C13.9689 3.6012 11.7359 4.3502 10.49 5.13419L10.371 5.21119C10.168 5.33719 9.83196 5.33719 9.62896 5.21119L9.45396 5.1062C8.20797 4.3292 5.98198 3.5872 4.51199 3.4682C3.679 3.3982 3 4.0282 3 4.8612V13.3171C3 13.9891 3.546 14.6191 4.21799 14.7031L4.42099 14.7311C5.93998 14.9341 8.28497 15.7041 9.62896 16.4391L9.65696 16.4531C9.84596 16.5581 10.147 16.5581 10.329 16.4531C11.6729 15.7111 14.0249 14.9341 15.5509 14.7311L15.7819 14.7031C16.4539 14.6191 16.9999 13.9891 16.9999 13.3171Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5.44336V15.9433"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0247 7.54297H5.44971"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5497 9.64355H5.44971"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Подписка (card-tick)
export function CardTickIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3.0083 8.54004H17"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.68805 15.886H6.11317C3.62964 15.886 3 15.2704 3 12.8148V7.0642C3 4.83951 3.51772 4.12593 5.46956 4.01399C5.66545 4.007 5.88231 4H6.11317H13.8856C16.3691 4H16.9988 4.61564 16.9988 7.07119V10.1564"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.80664 12.7373H8.60499"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 14.1372C17 14.6619 16.8531 15.1586 16.5942 15.5784C16.1115 16.3899 15.2231 16.9356 14.2017 16.9356C13.1803 16.9356 12.2918 16.3899 11.8091 15.5784C11.5502 15.1586 11.4033 14.6619 11.4033 14.1372C11.4033 12.5911 12.6556 11.3389 14.2017 11.3389C15.7478 11.3389 17 12.5911 17 14.1372Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1113 14.1358L13.8039 14.8284L15.294 13.4502"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Бизнес-модель (money/coin icon)
export function MoneyIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.22656 11.9412C7.22656 13.0162 8.05156 13.8829 9.07656 13.8829H11.1682C12.0599 13.8829 12.7849 13.1245 12.7849 12.1912C12.7849 11.1745 12.3432 10.8162 11.6849 10.5829L8.32656 9.41621C7.66823 9.18288 7.22656 8.82454 7.22656 7.80788C7.22656 6.87454 7.95156 6.11621 8.84323 6.11621H10.9349C11.9599 6.11621 12.7849 6.98288 12.7849 8.05788"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5V15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Маркетинговая стратегия (chart-trend-up)
export function ChartIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3 16.5V5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 16.5H17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 12.5L9.2 9.2C9.4 8.95 9.75 8.92 9.98 9.12L11.52 10.48C11.75 10.68 12.1 10.65 12.3 10.4L15.5 6.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 6.5H15.5V8.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Финансовая модель (calculator)
export function CalculatorIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M12.6002 17H7.4002C4.4002 17 3.0002 15.6 3.0002 12.6V7.4C3.0002 4.4 4.4002 3 7.4002 3H12.6002C15.6002 3 17.0002 4.4 17.0002 7.4V12.6C17.0002 15.6 15.6002 17 12.6002 17Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 7.89V6.11C14.25 5.44 13.81 5 13.14 5H6.86C6.19 5 5.75 5.44 5.75 6.11V7.89C5.75 8.56 6.19 9 6.86 9H13.14C13.81 9 14.25 8.56 14.25 7.89Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.12 11.4502H7.13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.4502H10.01"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.88 11.4502H12.89"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.12 14.0498H7.13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.0498H10.01"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.88 14.0498H12.89"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Обратная связь (message с текстом)
export function FeedbackIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6 4H14C15.6569 4 17 5.34315 17 7V11C17 12.6569 15.6569 14 14 14H10.5L7 16.5V14H6C4.34315 14 3 12.6569 3 11V7C3 5.34315 4.34315 4 6 4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 7.5H13.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 10.5H11"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Профиль/Настройки (setting)
export function SettingIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.99641 11.7028C11.1556 11.7028 12.0954 10.7631 12.0954 9.60383C12.0954 8.44462 11.1556 7.50488 9.99641 7.50488C8.83719 7.50488 7.89746 8.44462 7.89746 9.60383C7.89746 10.7631 8.83719 11.7028 9.99641 11.7028Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10.2196V8.98824C3 8.2606 3.5947 7.6589 4.32934 7.6589C5.5957 7.6589 6.11344 6.76335 5.47676 5.6649C5.11294 5.03521 5.32983 4.21662 5.96652 3.8528L7.17691 3.16015C7.72964 2.83132 8.44328 3.02722 8.77211 3.57994L8.84908 3.71287C9.47876 4.81133 10.5142 4.81133 11.1509 3.71287L11.2279 3.57994C11.5567 3.02722 12.2704 2.83132 12.8231 3.16015L14.0335 3.8528C14.6702 4.21662 14.8871 5.03521 14.5232 5.6649C13.8866 6.76335 14.4043 7.6589 15.6707 7.6589C16.3983 7.6589 17 8.2536 17 8.98824V10.2196C17 10.9473 16.4053 11.549 15.6707 11.549C14.4043 11.549 13.8866 12.4445 14.5232 13.543C14.8871 14.1796 14.6702 14.9912 14.0335 15.3551L12.8231 16.0477C12.2704 16.3765 11.5567 16.1806 11.2279 15.6279L11.1509 15.495C10.5212 14.3965 9.48576 14.3965 8.84908 15.495L8.77211 15.6279C8.44328 16.1806 7.72964 16.3765 7.17691 16.0477L5.96652 15.3551C5.32983 14.9912 5.11294 14.1726 5.47676 13.543C6.11344 12.4445 5.5957 11.549 4.32934 11.549C3.5947 11.549 3 10.9473 3 10.2196Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Конструктор сайта (monitor/browser window)
export function GlobeIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M5.1 3H14.9C16.3 3 17 3.7 17 5.1V12.6C17 14 16.3 14.7 14.9 14.7H5.1C3.7 14.7 3 14 3 12.6V5.1C3 3.7 3.7 3 5.1 3Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6.2H17"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.4 4.6H5.41M7.3 4.6H7.31"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.7V17M7.2 17H12.8"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
